/* Foberry customizer - extras v11: rail close button, ticker icon, style step from summary, size heading + scroll reset, unit switch, fit pictures, smart profile, summary extras, add-to-bag loading + fly animation */
(function () {
  if (window.__lgExtra) return;
  window.__lgExtra = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
  var Q = String.fromCharCode(34);
  function addCls(el, c) { if (el && !el.classList.contains(c)) el.classList.add(c); }
  function delCls(el, c) { if (el && el.classList.contains(c)) el.classList.remove(c); }
  function setText(el, v) { if (el && el.textContent !== v) el.textContent = v; }
  function tgl(el, c, on) { if (on) addCls(el, c); else delCls(el, c); }
  function once(fn) {
    var q = false;
    return function () {
      if (q) return;
      q = true;
      raf(function () { q = false; try { fn(); } catch (e) { if (window.console) console.warn('[glass+]', e); } });
    };
  }

  var SVG = {
    cam: "<svg class='cam' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'><path d='M4 8h3l1.5-2h7L17 8h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z'/><circle cx='12' cy='13' r='3.5'/></svg>",
    plus: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.6' stroke-linecap='round'><circle cx='12' cy='12' r='9'/><path d='M12 8v8M8 12h8'/></svg>",
    check: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'><path d='M21 12a9 9 0 1 1-4-7.5'/><path d='M8.5 12.5l2.5 2.5 5-6'/></svg>",
    x: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.2' stroke-linecap='round'><path d='M6 6l12 12M18 6L6 18'/></svg>",
    tag: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z'/><circle cx='7.5' cy='7.5' r='1.2'/></svg>"
  };

  /* ---------- 1. Close button: last item of the left rail (desktop) ---------- */
  function closeAnimated() {
    var m = document.getElementById('fullscreen-modal'), x = document.getElementById('close-modal');
    if (!m || !x) return;
    addCls(m, 'lg-closing');
    setTimeout(function () {
      x.click();
      setTimeout(function () { delCls(m, 'lg-closing'); }, 500);
    }, 300);
  }
  function mountClose() {
    var pi = $('.fabric_box .product-image');
    if (!pi || !$('.lg-dock')) return false;
    var b = $('.lg-close');
    if (!b) {
      b = document.createElement('button');
      b.type = 'button';
      b.className = 'lg-close';
      b.setAttribute('aria-label', 'Close customizer');
      b.innerHTML = SVG.x + '<span>Close</span>';
      b.addEventListener('click', closeAnimated);
    }
    if (pi.lastElementChild !== b) pi.appendChild(b);
    var ti = $('.lg-ticker-i');
    if (ti && !ti.firstChild) ti.innerHTML = SVG.tag;
    return true;
  }

  /* ---------- 2. Summary -> Step 01 (Style) lands on the main style page ---------- */
  function summaryOpen() {
    var sp = $('.custom_summary_page');
    return !!sp && !sp.classList.contains('hidden');
  }
  function clearFlags() {
    delCls($('.btn-prev-tab'), 'summary-page');
    delCls($('.mono-prev-tab'), 'summary-page');
  }
  var jumping = false;
  function openStyleOverview() {
    if (jumping) return;
    var m = $('.main-customizer-new'), ye = $('.summary_style .edit-btn');
    if (!ye) return;
    jumping = true;
    addCls(m, 'lg-jump');
    ye.click();
    var tries = 0;
    (function wait() {
      var list = $('.customizer-list.openchilds, .overview-list.openchilds');
      if (list && list.offsetParent !== null) {
        setTimeout(function () {
          clearFlags();
          var pv = $('.btn-prev-tab');
          if (pv) pv.click();
          setTimeout(function () { clearFlags(); delCls(m, 'lg-jump'); jumping = false; }, 450);
        }, 320);
      } else if (tries++ < 45) {
        setTimeout(wait, 100);
      } else {
        delCls(m, 'lg-jump');
        jumping = false;
      }
    })();
  }
  window.addEventListener('click', function (e) {
    var li = e.target && e.target.closest && e.target.closest('.lg-step');
    if (!li || li.getAttribute('data-step') !== '1' || !summaryOpen()) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    openStyleOverview();
  }, true);
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var li = e.target && e.target.closest && e.target.closest('.lg-step');
    if (!li || li.getAttribute('data-step') !== '1' || !summaryOpen()) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    openStyleOverview();
  }, true);

  /* ---------- 3. Size step: clear heading + always start from the top ---------- */
  var lastKey = '';
  function resetScroll() {
    ['.product_form_wrapper', '.customizer_content', '.create-sizes-row', '.main-customizer-new'].forEach(function (sel) {
      var el = $(sel);
      if (el) el.scrollTop = 0;
    });
  }
  function tune() {
    var s = $('.create-size');
    if (!s) return;
    var hidden = s.classList.contains('hidden');
    var v = s.getAttribute('data-lg-view') || 'select';
    setText(s.querySelector(':scope > h2'), v === 'panel' ? 'Create a size' : 'Choose a method to provide your size');
    setText($('.lg-size-intro', s), 'Pick the option that suits you best.');
    var key = (hidden ? 'h' : 'v') + v;
    if (key !== lastKey) {
      lastKey = key;
      if (!hidden) { resetScroll(); setTimeout(resetScroll, 80); setTimeout(resetScroll, 260); }
    }
  }

  /* ---------- 4. Product form helpers (unit + pictures travel with the order) ---------- */
  function formEl() {
    var b = $('.add-to-cart'), f = b && b.closest('form');
    if (f && !f.id) f.id = 'lg-product-form';
    return f;
  }
  function paneKind(p) {
    var list = $('.create-size-list');
    var a = p && p.id && list && $('a[href=' + Q + '#' + p.id + Q + ']', list);
    return a ? a.getAttribute('data-lg') : '';
  }
  function activeKind() {
    var a = $('.create-size-list a.active');
    if (a) return a.getAttribute('data-lg') || '';
    var p = $('.create-size .tab-pane.active');
    return p ? paneKind(p) : '';
  }
  var unit = 'in';
  var KEYS = [['front', 'Full body front'], ['side', 'Full body side'], ['back', 'Full body back'], ['other', 'Other']];
  var NAMES = { front: 'Front', side: 'Side', back: 'Back', other: 'Other' };
  var picInputs = {}, picUrls = {};

  function unitInput() {
    var el = $('input[data-lg-f=' + Q + 'unit' + Q + ']');
    if (!el) {
      var s = $('.create-size');
      if (!s) return null;
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'properties[Measurement unit]';
      el.setAttribute('data-lg-f', 'unit');
      el.disabled = true;
      s.appendChild(el);
    }
    return el;
  }
  function picCount() {
    var n = 0;
    KEYS.forEach(function (k) { var i = picInputs[k[0]]; if (i && i.files && i.files.length) n++; });
    return n;
  }
  function syncForm() {
    var f = formEl();
    if (!f) return;
    var kind = activeKind(), measure = kind === 'shirt' || kind === 'body';
    var u = unitInput();
    if (u) {
      u.setAttribute('form', f.id);
      u.value = unit === 'cm' ? 'Cm' : 'Inches';
      u.disabled = !measure;
    }
    KEYS.forEach(function (k) {
      var i = picInputs[k[0]];
      if (!i) return;
      i.setAttribute('form', f.id);
      i.disabled = !(i.files && i.files.length);
    });
  }
  window.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.add-to-cart')) syncForm();
  }, true);

  /* ---------- 5. Inches / Cm switch ---------- */
  function fmt(v) { return String(Math.round(v * 100) / 100); }
  function setUnit(u) {
    if (u === unit) { paintSeg(); return; }
    var s = $('.create-size');
    if (!s) return;
    $$('.measure-list input[type=number]', s).forEach(function (i) {
      if (i.dataset.lgMin === undefined) {
        i.dataset.lgMin = i.getAttribute('min') || '';
        i.dataset.lgMax = i.getAttribute('max') || '';
        i.dataset.lgStep = i.getAttribute('step') || '';
      }
      var v = parseFloat(i.value);
      if (u === 'cm') {
        if (i.dataset.lgMin !== '') i.setAttribute('min', fmt(parseFloat(i.dataset.lgMin) * 2.54));
        if (i.dataset.lgMax !== '') i.setAttribute('max', fmt(parseFloat(i.dataset.lgMax) * 2.54));
        i.setAttribute('step', '0.1');
        if (!isNaN(v)) i.value = String(Math.round(v * 2.54 * 10) / 10);
      } else {
        ['Min', 'Max', 'Step'].forEach(function (n) {
          var a = n.toLowerCase(), o = i.dataset['lg' + n];
          if (o === '' || o === undefined) i.removeAttribute(a); else i.setAttribute(a, o);
        });
        if (!isNaN(v)) i.value = String(Math.round(v / 2.54 * 4) / 4);
      }
      if (!isNaN(v)) i.dispatchEvent(new Event('input', { bubbles: true }));
    });
    $$('.measure-list .measuring-scale', s).forEach(function (el) { setText(el, u === 'cm' ? 'cm' : 'in'); });
    unit = u;
    paintSeg();
    syncForm();
  }
  function paintSeg() {
    $$('.lg-seg button').forEach(function (b) { tgl(b, 'is-on', b.getAttribute('data-u') === unit); });
  }
  function mountUnit() {
    $$('.create-size .tab-pane').forEach(function (p) {
      if (p.__lgu || !$('.measure-list', p)) return;
      p.__lgu = 1;
      var d = document.createElement('div');
      d.className = 'lg-unit';
      d.innerHTML = "<span>Measurement units</span><div class='lg-seg'><button type='button' data-u='in'>Inches</button><button type='button' data-u='cm'>Cm</button></div>";
      var host = $('.measure', p) || p;
      host.insertBefore(d, host.firstChild);
    });
    paintSeg();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.lg-seg button');
    if (b) setUnit(b.getAttribute('data-u'));
  });

  /* ---------- 6. Optional fit pictures ---------- */
  var picModal = null;
  function refreshPics() {
    var n = picCount();
    $$('.lg-pics-btn').forEach(function (b) {
      tgl(b, 'has', n > 0);
      var t = b.querySelector('.t');
      setText(t, n > 0 ? n + (n === 1 ? ' picture added' : ' pictures added') : 'Add pictures');
    });
    if (picModal) {
      var sk = $('.lg-skip', picModal);
      tgl(sk, 'is-done', n > 0);
      setText(sk, n > 0 ? 'Done' : "I don't want to send pictures");
    }
    syncForm();
  }
  function clearSlot(k) {
    var i = picInputs[k];
    if (i) i.value = '';
    if (picUrls[k]) { try { URL.revokeObjectURL(picUrls[k]); } catch (e) {} picUrls[k] = null; }
    var s = picModal && $('.lg-slot[data-k=' + Q + k + Q + ']', picModal);
    if (s) { delCls(s, 'has'); var im = $('img', s); if (im) im.removeAttribute('src'); setText($('.err', s), ''); }
  }
  function clearPics() {
    KEYS.forEach(function (k) { clearSlot(k[0]); });
    refreshPics();
  }
  function buildPics() {
    if (picModal) return picModal;
    var m = document.createElement('div');
    m.className = 'lg-pics';
    var slots = KEYS.map(function (k) {
      return "<div class='lg-slot' data-k='" + k[0] + "'><button type='button' class='rm' aria-label='Remove'>&times;</button><img alt=''>" + SVG.plus + "<span class='t'>" + k[1] + "</span><span class='err'></span></div>";
    }).join('');
    m.innerHTML = "<div class='lg-pics-card'><button type='button' class='lg-x' aria-label='Close'></button>" + SVG.cam + "<h3>Add pictures</h3><p class='sub'>They can help our tailors (if taken according to the guide) but they are not necessary.</p><div class='lg-slots'>" + slots + "</div><button type='button' class='lg-skip'>I don't want to send pictures</button></div>";
    document.body.appendChild(m);
    var card = $('.lg-pics-card', m);
    KEYS.forEach(function (k) {
      var inp = document.createElement('input');
      inp.type = 'file';
      inp.accept = 'image/*';
      inp.hidden = true;
      inp.name = 'properties[Fit picture - ' + NAMES[k[0]] + ']';
      inp.setAttribute('data-lg-f', k[0]);
      inp.disabled = true;
      card.appendChild(inp);
      picInputs[k[0]] = inp;
      inp.addEventListener('change', function () {
        var f = inp.files && inp.files[0], s = $('.lg-slot[data-k=' + Q + k[0] + Q + ']', m);
        if (!f) { clearSlot(k[0]); refreshPics(); return; }
        if (f.size > 15 * 1024 * 1024) { inp.value = ''; setText($('.err', s), 'File is too large (max 15 MB)'); refreshPics(); return; }
        if (picUrls[k[0]]) { try { URL.revokeObjectURL(picUrls[k[0]]); } catch (e) {} }
        picUrls[k[0]] = URL.createObjectURL(f);
        $('img', s).src = picUrls[k[0]];
        setText($('.err', s), '');
        addCls(s, 'has');
        refreshPics();
      });
    });
    m.addEventListener('click', function (e) {
      var t = e.target;
      if (t === m || (t.closest && t.closest('.lg-x'))) { closePics(); return; }
      if (t.closest && t.closest('.lg-skip')) {
        if (picCount() === 0) clearPics();
        closePics();
        return;
      }
      var rm = t.closest && t.closest('.rm');
      if (rm) { var s = rm.closest('.lg-slot'); clearSlot(s.getAttribute('data-k')); refreshPics(); e.stopPropagation(); return; }
      var slot = t.closest && t.closest('.lg-slot');
      if (slot) { var i = picInputs[slot.getAttribute('data-k')]; if (i) { i.disabled = false; i.click(); } }
    });
    picModal = m;
    refreshPics();
    return m;
  }
  function openPics() { addCls(buildPics(), 'is-open'); }
  function closePics() { delCls(picModal, 'is-open'); syncForm(); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePics(); });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.lg-pics-btn')) openPics();
  });
  function mountPicsRows() {
    $$('.create-size .tab-pane').forEach(function (p) {
      if (p.__lgp) return;
      p.__lgp = 1;
      var r = document.createElement('div');
      r.className = 'lg-pics-row';
      r.innerHTML = "<div><b>Pictures</b><p>Optional fit assessment images for our cutting master.</p></div><button type='button' class='lg-pics-btn'>" + SVG.cam + "<span class='t'>Add pictures</span></button>";
      p.appendChild(r);
    });
    refreshPics();
  }

  /* ---------- 7. Smart sizes: result card after the last answer ---------- */
  function updProfile() {
    var s = $('.create-size');
    if (!s) return;
    $$('.tab-pane', s).forEach(function (p) {
      if (paneKind(p) !== 'smart') return;
      var card = $('.lg-profile', p);
      if (!card) {
        card = document.createElement('div');
        card.className = 'lg-profile';
        card.innerHTML = SVG.check + "<b>Smart Profile Formulated</b><span class='lg-prof-line'></span><p>Our algorithm will recommend your perfect-fit size based on your answers.</p>";
        p.appendChild(card);
      }
      var nb = $('.btn-next-tab');
      var done = s.classList.contains('lg-last') && nb && !nb.classList.contains('disabled') && p.classList.contains('active');
      if (done) {
        var parts = [];
        $$('.question_sizes input:checked', p).forEach(function (i) {
          var li = i.closest('li'), t = li ? li.textContent.replace(/\s+/g, ' ').trim() : '';
          if (t && parts.indexOf(t) < 0) parts.push(t);
        });
        setText($('.lg-prof-line', card), parts.length ? 'Computed Profile: ' + parts.join(', ') : '');
      }
      tgl(card, 'is-on', !!done);
    });
  }

  /* ---------- 8. Measurement tags: inches shown as 15" ---------- */
  var fmtTags = once(function () {
    $$('.create-size .measure-list > li > .optional-or-required-tag.is-added').forEach(function (t) {
      var m = t.textContent.trim().match(/^(\d+(?:\.\d+)?)\s*in$/i);
      if (m) t.textContent = m[1] + Q;
    });
  });

  /* ---------- 9. Summary extras (unit + pictures) ---------- */
  var sumExtra = once(function () {
    var box = $('.summary_sizes');
    if (!box || !summaryOpen()) return;
    var old = $('.lg-sum-extra', box);
    var kind = activeKind(), measure = kind === 'shirt' || kind === 'body', n = picCount();
    var sig = (measure ? unit : '-') + '|' + KEYS.map(function (k) { return picUrls[k[0]] || ''; }).join(',');
    if (old && old.getAttribute('data-sig') === sig) return;
    if (old) old.remove();
    if (!measure && !n) return;
    var d = document.createElement('div');
    d.className = 'lg-sum-extra';
    d.setAttribute('data-sig', sig);
    var h = '';
    if (measure) h += "<div class='lg-sum-row'><span class='lg-sum-k'>Measurement unit</span><b>" + (unit === 'cm' ? 'Centimetres (cm)' : 'Inches (in)') + "</b></div>";
    if (n) {
      h += "<div class='lg-sum-row'><span class='lg-sum-k'>Fit pictures</span><div class='lg-sum-thumbs'>";
      KEYS.forEach(function (k) { if (picUrls[k[0]] && picInputs[k[0]] && picInputs[k[0]].files.length) h += "<img alt='' src='" + picUrls[k[0]] + "'>"; });
      h += '</div></div>';
    }
    d.innerHTML = h;
    box.appendChild(d);
  });

  /* ---------- 10. Add To Bag: loading sign + product flies into the bag ---------- */
  var busyTimer = null;
  function busyOn() {
    var b = $('.product_add .add-to-cart');
    clearTimeout(busyTimer);
    busyTimer = setTimeout(function () { addCls(b, 'lg-busy'); }, 200);
  }
  function busyOff() {
    clearTimeout(busyTimer);
    delCls($('.product_add .add-to-cart'), 'lg-busy');
  }
  function cartTarget() {
    var sels = ['cart-icon', '.header-actions__cart-icon', '[data-testid=' + Q + 'cart-icon' + Q + ']', 'a[href=' + Q + '/cart' + Q + ']', '#cart-icon-bubble', '.cart-bubble'];
    for (var i = 0; i < sels.length; i++) {
      var el = $(sels[i]);
      if (el && el.getBoundingClientRect().width > 0) return el;
    }
    return null;
  }
  function fly() {
    var src = $('.product_add > img') || $('.product_add img');
    if (!src || !src.offsetParent) return;
    var tgt = cartTarget();
    var r = src.getBoundingClientRect();
    var t = tgt ? tgt.getBoundingClientRect() : { left: window.innerWidth - 56, top: 24, width: 24, height: 24 };
    var el = document.createElement('img');
    el.className = 'lg-fly';
    el.alt = '';
    el.src = src.currentSrc || src.src;
    el.style.cssText = 'left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px';
    document.body.appendChild(el);
    var dx = t.left + t.width / 2 - (r.left + r.width / 2), dy = t.top + t.height / 2 - (r.top + r.height / 2);
    var done = function () {
      if (el.parentNode) el.parentNode.removeChild(el);
      if (tgt) { addCls(tgt, 'lg-bump'); setTimeout(function () { delCls(tgt, 'lg-bump'); }, 600); }
    };
    if (el.animate) {
      var a = el.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.25 - 70) + 'px) scale(.55)', opacity: 0.95, offset: 0.55 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.06)', opacity: 0.15 }
      ], { duration: 850, easing: 'cubic-bezier(.45,.05,.2,1)', fill: 'forwards' });
      a.onfinish = done;
    } else {
      setTimeout(done, 50);
    }
  }
  function hookFetch() {
    if (!window.fetch || window.fetch.__lgx) return;
    var of = window.fetch;
    var nf = function (u, o) {
      var p = of.apply(this, arguments);
      try {
        var url = (typeof u === 'string' ? u : (u && u.url)) || '';
        var method = (o && o.method) || (u && u.method) || 'GET';
        if (/\/cart\/add/.test(url) && /post/i.test(method) && $('.product_add .add-to-cart')) {
          busyOn();
          p.then(function (r) { busyOff(); if (r && r.ok) fly(); }, busyOff);
        }
      } catch (e) {}
      return p;
    };
    nf.__lgx = 1;
    window.fetch = nf;
  }
  hookFetch();

  /* ---------- fresh start: reset unit + pictures ---------- */
  window.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.start-button')) {
      setTimeout(function () { setUnit('in'); clearPics(); }, 0);
    }
  }, true);
  document.addEventListener('cart:update', function (e) {
    var d = e && e.detail && e.detail.data;
    if (d && d.source === 'custom-script') setTimeout(function () { setUnit('in'); clearPics(); }, 900);
  });

  /* ---------- mount ---------- */
  var tries = 0, wired = false;
  function wire() {
    var s = $('.create-size');
    if (!s || !s.getAttribute('data-lg-init') || wired) return false;
    wired = true;
    var upd = once(function () { tune(); mountUnit(); mountPicsRows(); updProfile(); fmtTags(); sumExtra(); syncForm(); });
    new MutationObserver(upd).observe(s, { attributes: true, attributeFilter: ['class', 'data-lg-view'], childList: true, subtree: true, characterData: true });
    s.addEventListener('change', upd);
    s.addEventListener('click', upd);
    var sp = $('.custom_summary_page');
    if (sp) new MutationObserver(upd).observe(sp, { attributes: true, attributeFilter: ['class'] });
    var sb = $('.summary_sizes');
    if (sb) new MutationObserver(upd).observe(sb, { childList: true });
    var nb = $('.btn-next-tab');
    if (nb) new MutationObserver(upd).observe(nb, { attributes: true, attributeFilter: ['class'] });
    upd();
    return true;
  }
  (function go() {
    mountClose();
    wire();
    if (!(wired && $('.lg-close')) && tries++ < 150) setTimeout(go, 150);
    else setTimeout(mountClose, 700);
  })();
})();
